import { FC } from 'react';
import { FAIcon, IconStyle } from '@nextgen-web-framework/all';
import { keyCheck } from '../../../utils';
import type { DropdownButtonPropsTypes } from './types/propTypes';
import styles from './DropdownButton.module.scss';
import { DropdownButtonTypeEnum } from './types/enums';

const DropdownButton: FC<DropdownButtonPropsTypes> = ({
  dropdownEventHandler,
  label,
  className,
  disabled,
  dropdownType = 'cpw-dropdown-container',
}: DropdownButtonPropsTypes): JSX.Element => {
  const keydownHandler = (e: React.KeyboardEvent): void => {
    if (keyCheck(e.code)) {
      dropdownEventHandler(e);
    }
  };

  const getDropdownType = () => {
    switch (dropdownType) {
      case DropdownButtonTypeEnum.CART_CARD_VARIANT:
        return 'cpw-dropdown-container-cart-card-variant';
      case DropdownButtonTypeEnum.CART_CARD_MOBILE_VARIANT:
        return 'cpw-dropdown-container-cart-card-variant-mobile-view-force';
      case DropdownButtonTypeEnum.CHECKOUT:
        return 'cpw-dropdown-container-checkout-variant';
      case DropdownButtonTypeEnum.PRODUCT_MERCHANDISE:
        return 'cpw-dropdown-container-product-merchandise';
      case DropdownButtonTypeEnum.PRODUCT_CARD:
        return 'cpw-dropdown-container-product-card';
      default:
        return 'cpw-dropdown-container';
    }
  };

  return (
    <div className={`${styles[getDropdownType()]} ${className}`} data-testid={getDropdownType()}>
      <button
        className={styles['cpw-dropdown']}
        onClick={dropdownEventHandler}
        onKeyDown={keydownHandler}
        data-testid="dropdown-test-id"
        disabled={disabled}
      >
        <span className={styles['cpw-dropdown-label']}>{label.replaceAll('_', ', ')}</span>
        <FAIcon iconName="chevron-down" className={styles['cpw-dropdown-icon']} iconStyle={IconStyle.REGULAR} />
      </button>
    </div>
  );
};

export default DropdownButton;
export type { DropdownButtonPropsTypes };
export { DropdownButtonTypeEnum };
